<template>
  <v-card @click="goTo()">
    <v-card-text class="d-flex align-center" v-if="$vuetify.display.smAndUp">
      <v-icon color="primary" :size="60" :icon="icon"></v-icon>
      <div class="pl-3">
        <h4 class="text-uppercase text-secondary">{{title}}</h4>
        <p class="mb-0 text-secondary text-h4">{{value}}</p>
      </div>
    </v-card-text>
    <v-card-text v-else>
      <h5  class="text-uppercase text-secondary">{{title}}</h5>
      <div class="d-flex align-center">
        <v-icon color="primary" :size="40" :icon="icon"></v-icon>
        <p class="mb-0 text-secondary text-h6 ml-3">{{value}}</p>
      </div>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import {useRouter} from "vue-router";
import {defineComponent} from "vue";

export default defineComponent({
  name: "Stat",
  props :{
    icon: String,
    title: String,
    value : [Number, String],
    to:String
  },
  setup(props, ctx) {
    const router = useRouter()
    return {
      goTo() {
        if(props.to) router.push(props.to)
      }
    }
  },
  methods : {

  }
})
</script>

<style scoped>

</style>
